import { getRecoil } from "recoil-nexus";
import _ from "lodash";

import { ISwarmGetFreeBetsRequest } from "src/common/swarm/models/request";
import { getPrice } from "src/rules/calculation/priceCalculation";
import mainStore, { storeSetFreeBets } from "src/stores/main";
import selectionsStore from "src/stores/selections";

import TerminalSwarmActions from "./swarmActions/terminal";
import { IFreeBet } from "src/constants/interfaces/bet";

const autoSelectSingleActive = (freeBets: IFreeBet[]) => {
  const isSingleActive = freeBets.filter((bonus) => !bonus.disabled).length === 1;

  if (!isSingleActive) return freeBets;

  return (
    freeBets.map((freeBet) => ({
      ...freeBet,
      selected: !freeBet.disabled,
    }))
  );
};

export const checkFreeBets = async () => {
  const { betType, isEachWay, priceChangeType, freeBets } = getRecoil(mainStore);
  const { selections } = getRecoil(selectionsStore);

  const request: ISwarmGetFreeBetsRequest = {
    type: betType,
    mode: priceChangeType,
    each_way: isEachWay,
    bets: selections.map(item => ({ event_id: item.event.id, price: getPrice(item) })),
  };

  const { details } = await TerminalSwarmActions.getFreeBets(request);

  const newFreeBets = details?.map((item) => ({
    details: item,
    disabled: false,
    selected: freeBets.some((freeBet) => freeBet.details.id === item.id && freeBet.selected),
  })) || [];

  const oldFreeBets = freeBets
    .filter((freeBet) => !newFreeBets.some(item => item.details.id === freeBet.details.id))
    .map((freeBet) => ({ ...freeBet, disabled: true }));

  storeSetFreeBets(
    autoSelectSingleActive([...newFreeBets, ...oldFreeBets])
  );
};